import { Theme } from "./Theme";
import common from "./common-theme-colors";

const theme: Theme = {
  backgroundHover: "rgba(0,0,0,0.05)",
  backgroundHoverInverted: "rgba(255,255,255,0.15)",
  backgroundHoverInvertedStatic: common.backgroundHoverInvertedStatic,
  backgroundHoverStatic: common.backgroundHoverStatic,
  backgroundPress: "rgba(0,0,0,0.05)",
  backgroundPressInverted: "rgba(255,255,255,0.15)",
  backgroundPressInvertedStatic: common.backgroundPressInvertedStatic,
  backgroundPressStatic: common.backgroundPressStatic,
  backgroundPrimary: "#FFFFFF",
  backgroundPrimaryElevated: "#FFFFFF",
  backgroundPrimaryInverted: "#131313",
  backgroundSecondary: "#F4F4F4",
  backgroundSecondaryInverted: "#272727",
  backgroundTertiary: "#CACACA",
  backgroundTertiaryInverted: "#3F3F3F",
  contentPrimary: "#131313",
  contentPrimaryInverted: "#FFFFFF",
  contentPrimaryInvertedStatic: common.contentPrimaryInvertedStatic,
  contentPrimaryStatic: common.contentPrimaryStatic,
  contentSecondary: "#777777",
  contentSecondaryInverted: "#E0E0E0",
  contentSecondaryInvertedStatic: common.contentSecondaryInvertedStatic,
  contentSecondaryStatic: common.contentSecondaryStatic,
  contentTertiary: "#BDBDBD",
  contentTertiaryInverted: "#828282",
  contentTertiaryInvertedStatic: common.contentTertiaryInvertedStatic,
  contentTertiaryStatic: common.contentTertiaryStatic,
  paletteBlue10: "#E8EBFF",
  paletteBlue20: "#B9C4FF",
  paletteBlue70: "#839BFD",
  paletteBlue100: common.paletteBlue100,
  paletteBlue200: common.paletteBlue200,
  paletteBlue300: common.paletteBlue300,
  paletteBrand10: "#FFE6E0",
  paletteBrand20: "#FFBCAD",
  paletteBrand70: "#FF8963",
  paletteBrand100: common.paletteBrand100,
  paletteBrand200: common.paletteBrand200,
  paletteBrand300: common.paletteBrand300,
  paletteGreen10: "#EFFCF9",
  paletteGreen20: "#CCF5EB",
  paletteGreen70: "#4DDBB8",
  paletteGreen100: common.paletteGreen100,
  paletteGreen200: common.paletteGreen200,
  paletteGreen300: common.paletteGreen300,
  paletteGrey10: "#F2F2F2",
  paletteGrey20: "#E0E0E0",
  paletteGrey70: "#BDBDBD",
  paletteGrey100: common.paletteGrey100,
  paletteGrey200: "#4F4F4F",
  paletteGrey300: "#222222",
  palettePurple10: "#F8F1FF",
  palettePurple20: "#DCB5FF",
  palettePurple70: "#B15AFE",
  palettePurple100: common.palettePurple100,
  palettePurple200: common.palettePurple200,
  palettePurple300: common.palettePurple300,
  paletteYellow10: "#FFF7E4",
  paletteYellow20: "#FFECB2",
  paletteYellow70: "#FFE084",
  paletteYellow100: common.paletteYellow100,
  paletteYellow200: common.paletteYellow200,
  paletteYellow300: common.paletteYellow300,
  serviceAmazonMusic: common.serviceAmazonMusic,
  serviceAppleMusic: common.serviceAppleMusic,
  serviceFacebook: common.serviceFacebook,
  serviceInstagram: common.serviceInstagram,
  serviceSpotify1: common.serviceSpotify1,
  serviceSpotify2: common.serviceSpotify2,
  serviceTikTok: "#000000",
  serviceTwitter: "#000000",
  serviceVimeo: common.serviceVimeo,
  serviceYoutube: common.serviceYoutube,
  shadow: common.shadow,
  systemBlue10: "#E3F2FD",
  systemBlue100: common.systemBlue100,
  systemBlue200: common.systemBlue200,
  systemGreen10: "#E8F5E9",
  systemGreen100: common.systemGreen100,
  systemGreen200: common.systemGreen200,
  systemMagenta10: "#FFE7F3",
  systemMagenta100: common.systemMagenta100,
  systemMagenta200: common.systemMagenta200,
  systemRed10: "#FFEBEE",
  systemRed70: "#FBB7B3",
  systemRed100: common.systemRed100,
  systemRed200: common.systemRed200,
  systemYellow10: "#FEF1D8",
  systemYellow100: common.systemYellow100,
  systemYellow200: common.systemYellow200,
};

export default theme;
